// React for Website
import React, { useState } from "react";
//outsource
import { Col, Form, Input } from "antd";

//components
const { TextArea } = Input;

const VoucherMessage = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const onChange = (e) => {
    const value = e.target.value;
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="message"
      label="Personalised message"
      rules={[
        {
          max: 1000,
          message: "Max length is 1000 character",
        },
      ]}
    >
      <TextArea
        maxLength={1000}
        rows={3}
        showCount
        placeholder="Happy birthday, have a wonderful day! "
        onChange={onChange}
      />
    </Form.Item>
  );
};

export default VoucherMessage;
